<ion-list [inset]="true">
  <ion-radio-group [value]="themeSrv.theme()" (ionChange)="selectItem($event.detail.value)">
    @for (theme of themeSrv.themes; track theme) {
      <ion-item>
        <ion-radio mode="md" [value]="theme">{{ themeSrv.themeLabels[theme] }}</ion-radio>
      </ion-item>
    }
  </ion-radio-group>
</ion-list>
